// All the demo data that used as fallbacks when there's nothing in the dataset yet

export const title = 'Generation Allergy Free';

export const description =
  'Generation Allergy Free believes that everyone should be allergy free. Our free research-focused courses make this a reality for generations to come.';

export const ogImageTitle = 'Generation Allergy Free';
